import React, { useState, useEffect } from "react";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Resize,
  Sort,
  ContextMenu,
  Filter,
  Page,
  ExcelExport,
  PdfExport,
  Inject,
} from "@syncfusion/ej2-react-grids";
import { Header } from "../Components";
import axios from "axios";
import {
  FaSearch,
  FaTrash,
  FaTimes,
  FaFileExcel,
  FaFilePdf,
  FaPlus,
  FaEdit,
} from "react-icons/fa";
import { useBaseUrl } from "../Contexts/BaseUrlContext";
import { useStateContext } from "../Contexts/ContextProvider";

// Grid column configuration
const circularGrid = [
  {
    field: "id",
    headerText: "ID",
    width: 80,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">ID</span>,
  },
  {
    field: "title",
    headerText: "Title",
    width: 150,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">Title</span>,
  },
  {
    field: "description",
    headerText: "Description",
    width: 200,
    textAlign: "Left",
    allowFiltering: true,
    headerTemplate: () => <span className="font-bold">Description</span>,
  },
  {
    field: "file_path",
    headerText: "PDF",
    width: 100,
    textAlign: "Center",
    template: (props) => (
      <a
        href={`https://riddhiedu.org/${props.file_path}`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 hover:text-blue-800"
      >
        <FaFilePdf size={18} />
      </a>
    ),
    headerTemplate: () => <span className="font-bold">PDF</span>,
  },
  {
    field: "date_time",
    headerText: "Date & Time",
    width: 120,
    format: "yMd",
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">Date & Time</span>,
  },
  {
    field: "Actions",
    headerText: "Actions",
    width: 120,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">Actions</span>,
    template: (props) => (
      <div className="flex justify-center gap-3">
        <button
          className="text-blue-600 hover:text-blue-800 transition-transform transform hover:scale-110 focus:outline-none"
          onClick={() => props.editHandler(props)}
          title="Edit"
        >
          <FaEdit size={18} />
        </button>
        <button
          className="text-red-600 hover:text-red-800 transition-transform transform hover:scale-110 focus:outline-none"
          onClick={() => props.deleteHandler(props.id)}
          title="Delete"
        >
          <FaTrash size={18} />
        </button>
      </div>
    ),
  },
];

const Circular = () => {
  const [circularData, setCircularData] = useState([]);
  const [selectedCircular, setSelectedCircular] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    pdf: null,
  });

  const { baseUrl } = useBaseUrl();

  // Fetch circular data from API
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    setErrorMessage("");
    try {
      const formData = new FormData();
      formData.append("action", "get-circular");

      const response = await axios.post(`${baseUrl}circular.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          // 'Accept': 'application/json',
        },
        withCredentials: true,
      });
      console.log("API Response:", response.data);
      if (response.data.status) {
        setCircularData(response.data.data || []);
      } else {
        setErrorMessage(response.data.error || "Failed to fetch circulars.");
      }
    } catch (error) {
      console.error("Axios Error:", error.response || error);
      setErrorMessage(
        "Error connecting to the server. Please check your network or API configuration."
      );
    } finally {
      setIsLoading(false);
    }
  };

  // Handle add circular
  const handleAddCircular = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");
    try {
      const data = new FormData();
      data.append("action", "add-circular");
      data.append("title", formData.title);
      data.append("description", formData.description);
      data.append("pdf_file", formData.pdf);

      const response = await axios.post(`${baseUrl}circular.php`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          // 'Accept': 'application/json',
        },
        withCredentials: true,
      });
      console.log("Add Response:", response.data);
      if (response.data.status) {
        fetchData();
        // setCircularData([...circularData, response.data.data]);
        setIsAddModalOpen(false);
        setFormData({ title: "", description: "", pdf: null });
        alert("Circular added successfully.");
      } else {
        setErrorMessage(response.data.error || "Failed to add circular.");
      }
    } catch (error) {
      console.error("Error adding circular:", error.response || error);
      setErrorMessage("Failed to add circular.");
    } finally {
      setIsLoading(false);
    }
  };

  // Handle edit circular
  const handleEditCircular = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");
    try {
      const data = new FormData();
      data.append("action", "update-circular");
      data.append("id", selectedCircular.id);
      data.append("title", formData.title);
      data.append("description", formData.description);
      if (formData.pdf_file) data.append("pdf_file", formData.pdf_file);

      const response = await axios.post(`${baseUrl}circular.php`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          // 'Accept': 'application/json',
        },
        withCredentials: true,
      });
      console.log("Edit Response:", response.data);
      if (response.data.status) {
        fetchData();
        // setCircularData(circularData.map(item => item.id === selectedCircular.id ? response.data.data : item));
        setIsEditModalOpen(false);
        setFormData({ title: "", description: "", pdf: null });
        setSelectedCircular(null);
        alert("Circular updated successfully.");
      } else {
        setErrorMessage(response.data.error || "Failed to update circular.");
      }
    } catch (error) {
      console.error("Error updating circular:", error.response || error);
      setErrorMessage("Failed to update circular.");
    } finally {
      setIsLoading(false);
    }
  };

  // Handle delete action
  const deleteHandler = async (id) => {
    if (window.confirm("Are you sure you want to delete this circular?")) {
      try {
        const data = new FormData();
        data.append("action", "delete-circular");
        data.append("id", id);

        const response = await axios.post(`${baseUrl}circular.php`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            // 'Accept': 'application/json',
          },
          withCredentials: true,
        });
        console.log("Delete Response:", response.data);
        if (response.data.status) {
          setCircularData(circularData.filter((item) => item.id !== id));
          alert("Circular deleted successfully.");
        } else {
          alert(
            "Failed to delete circular: " +
            (response.data.error || "Unknown error")
          );
        }
      } catch (error) {
        console.error("Error deleting circular:", error.response || error);
        alert("Failed to delete circular.");
      }
    }
  };

  // Handle edit action
  const editHandler = (circular) => {
    setSelectedCircular(circular);
    setFormData({
      title: circular.title,
      description: circular.description,
      pdf: null,
    });
    setIsEditModalOpen(true);
  };

  // Search filter
  const filteredData = circularData.filter(
    (item) =>
      item.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.description?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Inject handlers into grid data
  const gridData = filteredData.map((item) => ({
    ...item,
    editHandler,
    deleteHandler,
  }));

  const { setCurrentColor, setCurrentMode, currentMode } = useStateContext();

  useEffect(() => {
    const currentThemeColor = localStorage.getItem("colorMode");
    const currentThemeMode = localStorage.getItem("themeMode");
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }
  }, []);

  return (
    <div
      style={currentMode === "Dark" ? { backgroundColor: "#20232A" } : {}}
      className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8 animate-fadeIn bg-gray-100 min-h-screen"
    >
      <Header category="Dashboard" title="Circular Management" />

      {/* Error Message */}
      {errorMessage && (
        <div className="mb-4 p-4 bg-red-100 text-red-700 rounded-lg flex items-center">
          <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clipRule="evenodd"
            />
          </svg>
          {errorMessage}
        </div>
      )}

      {/* Search and Controls */}
      <div className="mb-6 flex flex-col sm:flex-row gap-4">
        <div className="relative flex-1">
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search by title or description..."
            className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 bg-white shadow-sm"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="flex gap-2">
          <button
            className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition duration-300 shadow-md"
            onClick={() => {
              setFormData({ title: "", description: "", pdf: null });
              setIsAddModalOpen(true);
            }}
          >
            <FaPlus className="mr-2" /> Add Circular
          </button>
          <button
            className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-300 shadow-md disabled:opacity-50"
            onClick={() =>
              document
                .getElementById("circularGrid")
                .ej2_instances[0].excelExport()
            }
            disabled={isLoading}
          >
            <FaFileExcel className="mr-2" /> Export Excel
          </button>
          <button
            className="flex items-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition duration-300 shadow-md disabled:opacity-50"
            onClick={() =>
              document
                .getElementById("circularGrid")
                .ej2_instances[0].pdfExport()
            }
            disabled={isLoading}
          >
            <FaFilePdf className="mr-2" /> Export PDF
          </button>
        </div>
      </div>

      {/* Loading Indicator */}
      {isLoading && (
        <div className="flex justify-center items-center py-4">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-600"></div>
        </div>
      )}

      {/* Grid */}
      <div className="bg-white rounded-xl shadow-lg overflow-hidden">
        <GridComponent
          id="circularGrid"
          dataSource={gridData}
          allowPaging={true}
          allowSorting={true}
          allowExcelExport={true}
          allowPdfExport={true}
          allowFiltering={true}
          allowResizing={true}
          pageSettings={{ pageSize: 10, pageSizes: [10, 20, 50] }}
          filterSettings={{ type: "Menu", showFilterBarStatus: true }}
        >
          <ColumnsDirective>
            {circularGrid.map((item, index) => (
              <ColumnDirective key={index} {...item} />
            ))}
          </ColumnsDirective>
          <Inject
            services={[
              Resize,
              Sort,
              ContextMenu,
              Filter,
              Page,
              ExcelExport,
              PdfExport,
            ]}
          />
        </GridComponent>
      </div>

      {/* Add Circular Modal */}
      {isAddModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animate-fadeIn">
          <div className="bg-white rounded-lg p-6 max-w-lg w-full shadow-2xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-gray-900">Add Circular</h2>
              <button
                className="text-gray-500 hover:text-gray-700 transition"
                onClick={() => setIsAddModalOpen(false)}
              >
                <FaTimes size={20} />
              </button>
            </div>
            <form onSubmit={handleAddCircular} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Title
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.title}
                  onChange={(e) =>
                    setFormData({ ...formData, title: e.target.value })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Description
                </label>
                <textarea
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                  rows={4}
                ></textarea>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  PDF File
                </label>
                <input
                  type="file"
                  accept="application/pdf"
                  className="w-full p-2 border border-gray-300 rounded-lg"
                  onChange={(e) =>
                    setFormData({ ...formData, pdf: e.target.files[0] })
                  }
                  required
                />
              </div>
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                  onClick={() => setIsAddModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
                  disabled={isLoading}
                >
                  Add Circular
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Circular Modal */}
      {isEditModalOpen && selectedCircular && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animate-fadeIn">
          <div className="bg-white rounded-lg p-6 max-w-lg w-full shadow-2xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-gray-900">
                Edit Circular
              </h2>
              <button
                className="text-gray-500 hover:text-gray-700 transition"
                onClick={() => setIsEditModalOpen(false)}
              >
                <FaTimes size={20} />
              </button>
            </div>
            <form onSubmit={handleEditCircular} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Title
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.title}
                  onChange={(e) =>
                    setFormData({ ...formData, title: e.target.value })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Description
                </label>
                <textarea
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                  rows={4}
                ></textarea>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  PDF File (optional)
                </label>
                <input
                  type="file"
                  accept="application/pdf"
                  className="w-full p-2 border border-gray-300 rounded-lg"
                  onChange={(e) =>
                    setFormData({ ...formData, pdf: e.target.files[0] })
                  }
                />
              </div>
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                  onClick={() => setIsEditModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
                  disabled={isLoading}
                >
                  Update Circular
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Circular;
